import React from 'react';
import {
    IonItem,
    IonLabel,
    IonInput,
    IonCheckbox,
    IonList,
    IonCard,
    IonCardContent,
    IonText,
    IonButton,
    IonSelect,
    IonSelectOption
} from '@ionic/react';
import { OCCUPANT_TYPE } from '../../../utils/constants';

const CalculateInvoiceStep = ({
    options,
    propertyOptions,
    properties,
    selectAllProperties,
    invoiceDate,
    rentSelected,
    otherSelected,
    penaltiesSelected,
    onInvoiceDateChange,
    onPropertiesChange,
    onRentToggle,
    onOtherToggle,
    onPenaltiesToggle,
    onToggleSelectAll,
    onContinue
}) => {
    const isFormValid = properties.length > 0 && invoiceDate && (rentSelected || otherSelected || penaltiesSelected);

    return (
        <div className="">
            <div className="ion-padding">
                <IonText color="primary">
                    <h1 style={{ fontSize: '1.75rem', fontWeight: 'bold' }}>Generate Invoices Form</h1>
                </IonText>
            
            <IonText color="medium">
                    Use this form to easily create invoices for all {options?.userAccountType === OCCUPANT_TYPE ? 'tenants' : 'members'} within a property.
            </IonText>
            </div>

            <IonCard>
                <IonCardContent style={{ padding: 0 }}>
                    <IonList>
                        <IonItem lines="none">
                            <IonLabel >
                                <strong>Select Properties</strong>
                            </IonLabel>
                        </IonItem>

                        <IonItem lines="none">
                            <IonSelect
                                multiple={true}
                                value={Array.isArray(properties) ? properties : []}
                                fill="solid"
                                onIonChange={(e) => {
                                    const value = e.detail.value;
                                    onPropertiesChange(Array.isArray(value) ? value : []);
                                }}
                                placeholder="Select properties"
                            >
                                {propertyOptions.map(prop => (
                                    <IonSelectOption key={prop.id} value={String(prop.id)}>
                                        {prop.label}
                                    </IonSelectOption>
                                ))}
                            </IonSelect>
                        </IonItem>

                        <IonItem>
                            <IonCheckbox
                                fill="outline"
                                checked={selectAllProperties}
                                onIonChange={(e) => onToggleSelectAll(e.detail.checked)}
                            />
                            <IonLabel className="ion-margin-start">Select All</IonLabel>
                        </IonItem>

                        <IonItem lines="none">
                            <IonLabel>
                                <strong>Invoice Date</strong>
                            </IonLabel>
                        </IonItem>

                        <IonItem>
                            <IonInput
                                type="date"
                                value={invoiceDate}
                                fill="solid"
                                onIonInput={(e) => onInvoiceDateChange(e.detail.value)}
                                placeholder="Select invoice date"
                                helperText="This date will be applied to all generated invoices."
                            />
                        </IonItem>

                        

                        <IonList>
                            <IonItem lines="none">
                                <IonLabel>
                                    <strong>Invoice Type</strong>
                                </IonLabel>
                            </IonItem>
                            <IonItem lines="none">
                                <IonCheckbox
                                    checked={rentSelected}
                                    onIonChange={(e) => onRentToggle(e.detail.checked)}
                                />
                                <IonLabel className="ion-margin-start">Rent</IonLabel>
                            </IonItem>
                            <IonItem lines="none">
                                <IonCheckbox
                                    checked={otherSelected}
                                    onIonChange={(e) => onOtherToggle(e.detail.checked)}
                                />
                                <IonLabel className="ion-margin-start">Other recurring bills</IonLabel>
                            </IonItem>
                            <IonItem lines="none">
                                <IonCheckbox
                                    checked={penaltiesSelected}
                                    onIonChange={(e) => onPenaltiesToggle(e.detail.checked)}
                                />
                                <IonLabel className="ion-margin-start">Penalties</IonLabel>
                            </IonItem>
                            <IonItem >
                            <IonText color="medium">
                                <small>
                                    Select the invoice types to create. Rent and Other recurring bills can be combined. Penalties cannot be combined with other types.
                                    </small>
                            </IonText>
                            </IonItem>
                        </IonList>

                        <IonItem lines="none" className="ion-margin-top">
                        <IonText color="medium">
                                Note that if an invoice have already been created for a {options?.userAccountType === OCCUPANT_TYPE ? 'tenant' : 'member'} for the specific month, they will not be created again.
                        </IonText>
                        </IonItem>
                    </IonList>
                </IonCardContent>
            </IonCard>

            <IonButton
                expand="block"
                onClick={onContinue}
                disabled={!isFormValid}
                className="ion-margin-top"
            >
                Continue to Preview
            </IonButton>
        </div>
    );
};

export default CalculateInvoiceStep;

